// import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import { ReactDOM } from "react";
import App from "./App";
// ReactDOM.render(<App />, document.querySelector("#root"));
const rootElement = document.getElementById("root");
ReactDOM.createRoot(rootElement).render(<App />);
